import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import DropDownComp from "./DropDownComp";
import InputComp from "./InputComp";
import { useEffect } from "react";
import Encrypt from "./../util/encrypt";
import CONSTANTS from "../util/constants";
import { useSelector } from "react-redux";

const OffSiteLocationModalComp = (props) => {
    console.log("props123",props);
  const typeOfModel = props.typeOfModel;
  const [rowData, setrowDataValue] = useState(
    props.rowData ? props.rowData : {}
  );
  const [locationName, setLocationName] = useState(
    props.rowDataUser && props.rowDataUser.name ? props.rowDataUser.name : ""
  );
  const [locationStreetAddress, setLocationStreetAddress] = useState(
    props.rowDataUser && props.rowDataUser.streetAddress
      ? props.rowDataUser.streetAddress
      : ""
  );
  const [city, setCity] = useState(
    props.rowDataUser && props.rowDataUser.city ? props.rowDataUser.city : ""
  );
  const [state, setState] = useState(
    props.rowDataUser && props.rowDataUser.state ? props.rowDataUser.state : ""
  );
  const [zip, setZip] = useState(
    props.rowDataUser && props.rowDataUser.zip ? props.rowDataUser.zip : ""
  );
  const [firstName, setFirstName] = useState(
    props.rowDataUser && props.rowDataUser.contactFirstName
      ? props.rowDataUser.contactFirstName
      : ""
  );
  const [lastName, setLastName] = useState(
    props.rowDataUser && props.rowDataUser.contactLastName
      ? props.rowDataUser.contactLastName
      : ""
  );
  const [phoneNumber, setPhoneNumber] = useState(
    props.rowDataUser && props.rowDataUser.phone ? props.rowDataUser.phone : ""
  );
  const [divisionsArray, setDivisionArray] = useState([]);
  const [userDivisionName, setUserDivisionName] = useState();
  const [loginResponse, setLoginResponse] = useState(null);
  let divisionsArrayTemp = useSelector(
    (state) => state.division.getDivisionData
  );
  divisionsArrayTemp = divisionsArrayTemp.filter((data,i)=>{
    return data?.is_active === true
 })
  useEffect(() => {
    let localstorageLR = localStorage.getItem("L_R");
    if (localstorageLR) {
      let data = localstorageLR ? Encrypt.dycryptData(localstorageLR) : "";
      let loginResponse = localstorageLR
        ? JSON.parse(data) != "" || JSON.parse(data) != null
          ? JSON.parse(data)
          : ""
        : "";
      setLoginResponse(loginResponse);
    }

    if (
      props.rowDataUser &&
      props.rowDataUser.divisions &&
      props.rowDataUser.divisions.length > 0
    ) {
      var data = [];
      for (var i = 0; i < props.rowDataUser.divisions.length; i++) {
        data.push({
          label: props.rowDataUser.divisions[i].divisionName,
          value: props.rowDataUser.divisions[i].division_id,
        });
      }
      setUserDivisionName(data);
    }
  }, []);

  useEffect(() => {
    var data = [];
    for (var i = 0; i < divisionsArrayTemp.length; i++) {
      data.push({
        label: divisionsArrayTemp[i].divisionName,
        value: divisionsArrayTemp[i].division_id,
      });
    }
    setDivisionArray(data);
  }, [loginResponse]);

  return (
    <Modal
      size="lg"
      show={props.isShow}
      onHide={props.handleClose}
      backdrop="static"
      centered
      keyboard={false}
    >
      <Modal.Header style={{ backgroundColor: "rgb(0, 42, 74)" }}>
        <Modal.Title style={{ fontFamily: "Roboto", color: "white" }}>
          {props.title ? props.title : "Add Off-Site Location"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {typeOfModel === "delete" ? (
          <>
            <div
              className="row container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "space-between",
              }}
            >
              <div className="col-12 col-md-12 col-sm-12 col-lg-12 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>
                    Are You Sure Want To Delete This Off-Site Location ?
                  </label>
                </div>

                
              </div>
            </div>
          </>
        ) : (
          <>
            <div
              className="row container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "space-between",
              }}
            >
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Location Name</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Location Name"}
                    maxLength={30}
                    placeholder={"Location Name"}
                    value={locationName}
                    onChangeHandler={(locationName) => {
                      setLocationName(locationName);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Contact Last Name</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Contact Last Name"}
                    maxLength={30}
                    placeholder={"Contact Last Name"}
                    value={lastName}
                    onChangeHandler={(lastName) => {
                      setLastName(lastName);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12 col-sm-12 col-lg-4 ">
                <div>
                  <label style={{ fontSize: 14 }}>City</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"City"}
                    maxLength={30}
                    placeholder={"City"}
                    value={city}
                    onChangeHandler={(city) => {
                      setCity(city);
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="row container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "space-between",
              }}
            >
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>State</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"State"}
                    maxLength={30}
                    placeholder={"State"}
                    value={state}
                    onChangeHandler={(state) => {
                      setState(state);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Zip</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Zip"}
                    maxLength={30}
                    placeholder={"Zip"}
                    value={zip}
                    inputType={"numeric"}
                    onChangeHandler={(zip) => {
                      setZip(zip);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 16, marginRight: 12 }}>
                    {"Division Name"}
                  </label>
                </div>
                <div>
                  <DropDownComp
                    styles={{
                      display: "flex",
                      flexDirection: "row",
                      alignSelf: "center",
                      alignItems: "center",
                      justifyContent: "center",
                      height: 35,
                      borderColor: "hsl(0, 0%, 50%)",
                      borderStyle: "solid",
                      borderWidth: "1px",
                    }}
                    name={"Select Division Name"}
                    options={divisionsArray}
                    isMulti={true}
                    onChange={(value) => {
                      setUserDivisionName(value);
                      console.log("Value division :" + JSON.stringify(value));
                    }}
                    value={userDivisionName}
                  />
                </div>
              </div>

              {/* {props.OffSite ? */}

              {/* : <div className="col-12 col-md-12 col-sm-12 col-lg-4" />
} */}
            </div>

            <div
              className="row container"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "space-between",
              }}
            >
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Contact First Name </label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Contact First Name"}
                    maxLength={30}
                    placeholder={"Contact First Name"}
                    value={firstName}
                    onChangeHandler={(firstName) => {
                      setFirstName(firstName);
                    }}
                  />
                </div>
              </div>
              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>
                    Location Street Address
                  </label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Location Street Address"}
                    maxLength={30}
                    placeholder={"Location Street Address"}
                    value={locationStreetAddress}
                    onChangeHandler={(locationStreetAddress) => {
                      setLocationStreetAddress(locationStreetAddress);
                    }}
                  />
                </div>
              </div>

              <div className="col-12 col-md-12 col-sm-12 col-lg-4 mb-2">
                <div>
                  <label style={{ fontSize: 14 }}>Contact Phone Number</label>
                </div>

                <div>
                  <InputComp
                    style={{
                      width: "100%",
                      borderColor: "hsl(0, 0%, 50%)",
                      borderRadius: "4px",
                      borderStyle: "solid",
                      borderWidth: "1px",
                      padding: "4px",
                      fontSize: 14,
                    }}
                    labelName={"Contact Phone Number"}
                    maxLength={30}
                    placeholder={"Contact Phone Number"}
                    value={phoneNumber}
                    inputType={"numeric"}
                    onChangeHandler={(phoneNumber) => {
                      setPhoneNumber(phoneNumber);
                    }}
                  />
                </div>
              </div>
            </div>
          </>
        )}
      </Modal.Body>

      <Modal.Footer>
        <div
          className="row col-12 col-sm-12 col-md-12 col-lg-12"
          style={{ display: "flex", justifyContent: "space-around" }}
        >
          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              onClick={() => {
                let OffSiteLocObj;
                let divisionArr = [];
                if (userDivisionName != null && userDivisionName?.length > 0) {
                  for (let i = 0; i < userDivisionName.length > 0; i++) {
                    if (
                      props.OffSiteLocation &&
                      props.rowDataUser != null &&
                      props.rowDataUser.divisions?.length > 0
                    ) {
                      for (
                        let j = 0;
                        j < props.rowDataUser.divisions.length > 0;
                        j++
                      ) {
                        if (
                          userDivisionName[i].value ==
                          props.rowDataUser.divisions[j].division_id
                        ) {
                          divisionArr.push({
                            division_id: userDivisionName[i].value,
                            divisionToLocation_id:
                              props.rowDataUser.divisions[j].divisionToLocation
                                .divisionToLocation_id,
                          });
                        } else {
                          divisionArr.push({
                            division_id: userDivisionName[i].value,
                            divisionToLocation_id: "",
                          });
                        }
                      }
                    } else {
                      divisionArr.push({
                        division_id: userDivisionName[i].value,
                        divisionToLocation_id: "",
                      });
                    }
                  }
                  console.log("divisionArr :" + JSON.stringify(divisionArr));
                }
                if (locationName == "") {
                  alert("Please Enter Location Name");
                } else if (city == "") {
                  alert("Please Enter City");
                } else if (state == "") {
                  alert("Please Enter State");
                } else if (zip == "") {
                  alert("Please Enter Zip");
                }

                // else if (phoneNumber == '') {
                //     alert('Please Enter Contact Number')
                // }
                else if (locationStreetAddress == "") {
                  alert("Please Enter Street Address");
                } 
                else if (typeOfModel === "delete") {
                    OffSiteLocObj = {
                      id: props.rowDataUser?.location_id
                        ? props.rowDataUser?.location_id
                        : "",
                      name: locationName ? locationName : "",
                      zip: zip,
                      state: state,
                      phone: phoneNumber,
                      firstName: firstName,
                      lastName: lastName,
                      streetAddress: locationStreetAddress,
                      city: city,
                      userDivisionName: userDivisionName,
                      divisions: divisionArr,
                      is_active:false,
                      test:"gmail"
                    };
                    props.setValue(OffSiteLocObj);
                  } 
                else if (props.OffSiteLocation && props.rowDataUser != null) {
                  OffSiteLocObj = {
                    id: props.rowDataUser?.location_id
                      ? props.rowDataUser?.location_id
                      : "",
                    name: locationName ? locationName : "",
                    zip: zip,
                    state: state,
                    phone: phoneNumber,
                    firstName: firstName,
                    lastName: lastName,
                    streetAddress: locationStreetAddress,
                    city: city,
                    userDivisionName: userDivisionName,
                    divisions: divisionArr,
                  };
                  props.setValue(OffSiteLocObj);
                } 
                
                else {
                  OffSiteLocObj = {
                    name: locationName ? locationName : "",
                    zip: zip,
                    state: state,
                    phone: phoneNumber,
                    firstName: firstName,
                    lastName: lastName,
                    streetAddress: locationStreetAddress,
                    city: city,
                    divisions: divisionArr,
                  };
                  console.log(
                    "OffSiteLocObj :" + JSON.stringify(OffSiteLocObj)
                  );
                  props.setValue(OffSiteLocObj);
                }
              }}
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {typeOfModel === 'delete' ? 'Delete Off-site Location' : props.OffSiteLocation && props.rowDataUser != null
                ? "Edit Off-site Location"
                : props.OffSiteLocation
                ? "Add Off-site Location"
                : "Add Move"}
            </button>
          </div>

          <div className="col-12 col-sm-12 col-md-12 col-lg-6">
            <button
              style={{
                backgroundColor: "#002a4a",
                height: "80%",
                color: "white",
                width: "100%",
                borderRadius: 8,
                borderWidth: 1,
              }}
              onClick={() => {
                props.show(false);
              }}
              className="btn btn-primary"
              variant="primary"
            >
              {"Cancel"}
            </button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
export default OffSiteLocationModalComp;
